import { render } from "./ExportImage.vue?vue&type=template&id=f3b295a8&scoped=true&ts=true"
import script from "./ExportImage.vue?vue&type=script&lang=ts"
export * from "./ExportImage.vue?vue&type=script&lang=ts"

import "./ExportImage.vue?vue&type=style&index=0&id=f3b295a8&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3b295a8"]])

export default __exports__